module.exports = __webpack_public_path__ + "static/media/jetsuitex-480p.ce7ac447.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/video/jetsuitex-480p.mov
// module id = 501
// module chunks = 0